import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { version } from './injectables';
import { AuthService } from 'wecheer-amplify';
import { PERMISSION } from './const/permission';
import { CampaignsVersionApiClient } from './api/api-campaigns.service.generated';
import { Router } from "@angular/router";
import { GroupMenus, LayoutComponent, UIManagementService } from 'wecheer-common';
import { AppVersionService } from './common/services/app-version.service';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { environment } from 'src/environments/environment';
import { UserPermissionsService } from './common/services/user-permissions.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
imports: [
    RouterModule,
    LayoutComponent,
    CommonModule
  ]
})
export class AppComponent implements OnInit {
  authService = inject(AuthService);
  campaignVersion = inject(CampaignsVersionApiClient);
  private uiManagementService = inject(UIManagementService);
  private router = inject(Router);
  private appversion: AppVersionService = inject(AppVersionService);
  private userPermissionsService = inject(UserPermissionsService);


  version: string;
  apiVersion$: Observable<string>;

  hasReadPermission = false;
  hasWritePermission = false;
  signedIn = false;

  user: string;
  email: string;

  groupMenus: GroupMenus[] = [];
  logoUrl = './assets/imgs/logo.svg';

  constructor() {
    const injectedVersion = inject(version, { optional: true });

    this.version = injectedVersion ? injectedVersion : '';
  }

  ngOnInit() {
    this.uiManagementService.setEnvironment(environment);
    this.groupMenus = [
      {
        name: "Menu",
        icon: 'menu',
        menus: [
          {
            name: 'Fraud Detection',
            url: 'fraud-detection',
            icon: 'search',
            hasPermission: true
          },
          {
            name: 'Safeboxes',
            url: 'safeboxes',
            icon: 'lock',
            hasPermission: true
          },
          {
            name: 'Advertisers',
            url: 'advertisers',
            icon: 'business',
            hasPermission: true
          },
          {
            name: 'Receipts',
            url: 'receipts',
            icon: 'receipt',
            hasPermission: true
          },
          {
            name: 'Receipt Codes',
            url: 'receipt-codes',
            icon: 'code',
            hasPermission: true
          }
        ]
      }
    ]

    // Fetch the access token and permissions and domain list
    this.authService.getAccessToken().subscribe((token) => {
      if (!token) return;

      this.signedIn = true;
      this.uiManagementService.getReadPermissions();

      this.userPermissionsService.hasPermission(PERMISSION.CAMPAIGNMANAGEMENT_READ)
        .subscribe(v => this.hasReadPermission = v);
      this.userPermissionsService.hasPermission(PERMISSION.CAMPAIGNMANAGEMENT_WRITE)
        .subscribe(v => this.hasWritePermission = v);

      setTimeout(() => {
        const user = this.authService.user;
        this.email = user.signInDetails.loginId;
      });

      this.appversion.init();

      const jwt = this.authService.parseJwt(token);
      const cognitoGroups = jwt?.['cognito:groups'] || [];

      const advertiserIdString = cognitoGroups.find(item => item?.startsWith('AdvertiserId.Read:'));
      let advertiserIds = [];
      if (advertiserIdString) {
        try {
          advertiserIds = JSON.parse(advertiserIdString.substring('AdvertiserId.Read:'.length));
        } catch (error) {
          console.error('Error parsing advertiser IDs:', error);
        }
      }

      if (advertiserIds?.length > 0) {
        this.router.navigate(['/advertisers', advertiserIds[0]]);
      }
    });
  }

  onLogout(event: boolean) {
    this.signedIn = false;
    if (event) this.authService.logout();
  }
}
